module.exports = "/assets/data/41ebf654b6ad4d0dac97598c1227dbcc-SE19.data.json";